import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=8a9c2292&"
import script from "./footer.vue?vue&type=script&lang=js&"
export * from "./footer.vue?vue&type=script&lang=js&"
import style0 from "./footer.vue?vue&type=style&index=0&id=8a9c2292&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconOrnament: require('/opt/airport.kg/src/components/icon/ornament.vue').default,BaseLogo: require('/opt/airport.kg/src/components/base/logo.vue').default,IconInstagram: require('/opt/airport.kg/src/components/icon/instagram.vue').default,IconFacebook: require('/opt/airport.kg/src/components/icon/facebook.vue').default,IconTwitter: require('/opt/airport.kg/src/components/icon/twitter.vue').default,RzContainer: require('/opt/airport.kg/node_modules/razlet-ui/src/components/container/index.vue').default})
